import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export function useLaunchConfig(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'launch', 'config'],
    queryFn: () => apiClient.launch.getConfig(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useLaunchForecast(clientId: string | undefined) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => apiClient.launch.forecast(clientId!, data),
    onSuccess: () => {
      // Invalidate related queries if needed
      queryClient.invalidateQueries({ queryKey: ['client', clientId, 'launch'] });
    },
  });
}
